import { render } from "./DealDetailsPopup.vue?vue&type=template&id=06a0e744&ts=true"
import script from "./DealDetailsPopup.vue?vue&type=script&lang=ts"
export * from "./DealDetailsPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__